// extracted by mini-css-extract-plugin
export default {"CountriesFeature":"wc_a bhs_b"};